jQuery(document).ready(function ($) {
    'use strict';

    $('[data-quotes-slider]').each(function (index) {
        var $swiper = $(this);
        var swiperId = 'quotes-swiper-' + index;

        $swiper.attr('data-id', swiperId);

        new Swiper('[data-id="' + swiperId + '"]', {
            speed: 600,
            loop: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            grabCursor: true,
            slidesPerView: 1,
            centeredSlides: true,
            pagination: {
                el: $swiper.find('.swiper-pagination')[0],
                clickable: true,
            },
        });
    });
});

//# sourceMappingURL=swiper-quotes.js.map
